<template>
  <div class="controller-curose my-5">
      <div class="d-flex justify-content-between">
        <button class="font-16 px-5 py-2 bttn-fill bttn-royal" v-ripple @click.stop="prevStep" v-if="fullPatch !== '/dashboard/new-course'">
          مرحله قبل
        </button>
        <slot></slot>
        <!-- <button class="font-16 px-5 py-2 bttn-fill bttn bttn-royal" v-ripple @click="save" v-if="fullPatch  === '/dashboard/messages'">
          ثبت نهایی
        </button> -->
        <!-- <button class="font-16 px-5 py-2  bttn-minimal bttn bttn-success" v-ripple @click="draft">
                    ذخیره به عنوان پیش نویس
                </button> -->
      </div>
  </div>
</template>

<script>
export default {
  name: 'controller',
  computed: {
    fullPatch () {
      return this.$route.path
    }
  },
  methods: {
    nextStep () {

    },
    prevStep () {
      if (this.fullPatch === '/dashboard/messages') {
        this.$router.push('/dashboard/goals')
        return
      }
      if (this.fullPatch === '/dashboard/goals') {
        this.$router.push('/dashboard/sections')
        return
      }
      if (this.fullPatch === '/dashboard/sections') {
        if (window.sessionStorage.getItem('isMultiInst')) {
          this.$router.push('/dashboard/instructors')
          return
        } else {
          this.$router.push('/dashboard/new-course')
          return
        }
      }
      if (this.fullPatch === '/dashboard/instructors') {
        this.$router.push('/dashboard/new-course')
      }
    },
    save () {
      this.$router.push('/dashboard/messages')
    },
    draft () {

    }
  }
}
</script>

<style lang="less">
.controller-curose {
}
</style>



// WEBPACK FOOTER //
// src/components/controller-curose.vue